import * as config from '@/config';
import * as AwsSigningUtils from '@/library/utils/aws-signing';

// Recuperar valores de entorno
const URL_BASE = config.URL_API_BOLETAS;

// Funciones
export const emisoresUsuario = function(usuario, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_BASE}/api/info-contribuyente/emisores-usuario/${usuario}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};

export const infoEmisorUsuario = function(contribuyente, usuario, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_BASE}/api/info-contribuyente/info-emisor-usuario/${contribuyente}/${usuario}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};

export const infoReceptor = function(contribuyente, thenFun, catchFun) {
	let method = 'GET';
	let url = `${URL_BASE}/api/info-contribuyente/info-receptor/${contribuyente}`;
	let data = undefined;
	AwsSigningUtils.executeSignedRequest(method, url, data, thenFun, catchFun);
};
